// leadOptions.js

export const salutationOptions = [
    { value: '', label: 'Keine Auswahl', isEmpty: true },
    { value: 'Herr', label: 'Herr' },
    { value: 'Frau', label: 'Frau' },
    { value: 'Divers', label: 'Divers' }
  ];

export const titleOptions = [
    { value: '', label: 'Keine Auswahl', isEmpty: true },
    { value: 'dr', label: 'Dr.' },
    { value: 'prof', label: 'Prof.' },
    { value: 'prof_dr', label: 'Prof. Dr.' },
    { value: 'ing', label: 'Ing.' },
    { value: 'dipl_ing', label: 'Dipl.-Ing.' },
    { value: 'mag', label: 'Mag.' },
    { value: 'bsc', label: 'BSc.' },
    { value: 'msc', label: 'MSc.' },
  ];

// lead only
export const statusOptions = [
    { value: 'Open', label: 'Offen' },
    { value: 'Contacted', label: 'Kontaktiert' },
    { value: 'Interested', label: 'Interessiert' },
    { value: 'Closed Won', label: 'Gewonnen' },
    { value: 'Declined', label: 'Abgelehnt' }
  ];

export const sourceOptions = [
    { value: '', label: 'Keine Auswahl', isEmpty: true },
    { value: 'Website', label: 'Website' },
    { value: 'Campaign', label: 'Kampagne' },
    { value: 'Event', label: 'Event' },
    { value: 'Referral', label: 'Empfehlung' },
    { value: 'Socials', label: 'Soziale Medien' }
  ];

export const scoreOptions = [
    { value: '', label: 'Keine Auswahl', isEmpty: true },
    { value: 'Cold', label: 'Kalt' },
    { value: 'Warm', label: 'Warm' },
    { value: 'Hot', label: 'Heiß' }
  ];

// contact only
export const typeOptions = [
    { value: 'Customer', label: 'Kunde' },
    { value: 'Partner', label: 'Partner' },
    { value: 'Supplier', label: 'Anbieter' },
    { value: 'Other', label: 'Sonstige' }
  ];

export const priorityOptions = [
    { value: 'A+', label: 'A+' },
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
    { value: 'C', label: 'C' },
    { value: 'D', label: 'D' }
  ];
